import React from 'react';
import Image from 'next/image';
import edgyCloseNext from '../../svgs/edgy_close_icon.svg';
import { NextImageProps } from '../NextImageProps';

export function EdgyCloseNext({ className, width, height, alt }: NextImageProps) {
  return (
    <Image
      width={width}
      height={height}
      className={className}
      src={edgyCloseNext}
      alt={alt ?? 'Luk'}
    />
  );
}
